const styles = theme => ({
  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '10px',
  },
  closeButtonDraggable: {
    position: 'absolute',
    top: '21px',
    right: '10px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'grab',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    width: '100%',
    padding: '6px 0px',
  },
  titleStyle: {
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'Inter',
  },
  titleStyleDraggable: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
  },
})

export default styles
